export default function isTouchEventFromStylus(event: TouchEvent): boolean {
  return event.touches[0]?.radiusX === 0 && event.touches[0]?.radiusY === 0;
}
